export enum LEARNER_DETAIL {
  PROFILE = 'profile',
  LESSON_SCHEDULE = 'lesson-schedule',
  CLASS_RESULTS = 'class-results',
}

export enum SurveyType {
  FUNCTIONAL_SCALE = 'functional-scale',
}
